export default "/images/35fbf2fa10e184c5031b2b792346fc96.avif";